import { application } from "./application"

import AvatarUploadController from "./avatar_upload_controller"
application.register("avatar-upload", AvatarUploadController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import CharacterCounter from "@stimulus-components/character-counter"
application.register("character-counter", CharacterCounter)

import Clipboard from "@stimulus-components/clipboard"
application.register("clipboard", Clipboard)

import CompletionController from "./completion_controller"
application.register("completion", CompletionController)

import ComponentsPasteChipsController from "./components_paste_chips_controller"
application.register("components-paste-chips", ComponentsPasteChipsController)

import Dialog from "@stimulus-components/dialog"
application.register("dialog", Dialog)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EasyMDEController from "./easymde_controller"
application.register("easymde", EasyMDEController)

import EditableFieldController from "./editable_field_controller"
application.register("editable-field", EditableFieldController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import GalleryOverlayController from "./gallery_overlay_controller"
application.register("gallery-overlay", GalleryOverlayController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import PhotoSortableController from "./photo_sortable_controller"
application.register("photo-sortable", PhotoSortableController)

import RailsNestedForm from "@stimulus-components/rails-nested-form"
application.register("nested-form", RailsNestedForm)

import RoomWizardController from "./room_wizard_controller"
application.register("room-wizard", RoomWizardController)

import ShareModalController from "./share_modal_controller"
application.register("share-modal", ShareModalController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
